export const SELECT_COUNTRY_REQUEST = "SELECT_COUNTRY_REQUEST";
export const SELECT_COUNTRY_SUCCESS = "SELECT_COUNTRY_SUCCESS";
export const SELECT_COUNTRY_FAILURE = "SELECT_COUNTRY_FAILURE";
export const SELECT_STATE_REQUEST = "SELECT_STATE_REQUEST";
export const SELECT_STATE_SUCCESS = "SELECT_STATE_SUCCESS";
export const SELECT_STATE_FAILURE = "SELECT_STATE_FAILURE";
export const SELECT_CITY_REQUEST = "SELECT_CITY_REQUEST";
export const SELECT_CITY_SUCCESS = "SELECT_CITY_SUCCESS";
export const SELECT_CITY_FAILURE = "SELECT_CITY_FAILURE";
export const SELECT_COUNTRY_AIRPORT_REQUEST = "SELECT_COUNTRY_AIRPORT_REQUEST";
export const SELECT_COUNTRY_AIRPORT_SUCCESS = "SELECT_COUNTRY_AIRPORT_SUCCESS";
export const SELECT_COUNTRY_AIRPORT_FAILURE = "SELECT_COUNTRY_AIRPORT_FAILURE";
export const SELECT_STATE_AIRPORT_REQUEST = "SELECT_STATE_AIRPORT_REQUEST";
export const SELECT_STATE_AIRPORT_SUCCESS = "SELECT_STATE_AIRPORT_SUCCESS";
export const SELECT_STATE_AIRPORT_FAILURE = "SELECT_STATE_AIRPORT_FAILURE";
